export default {"src":"/_next/static/media/roadmap.a660e089.svg","height":156,"width":163,"blurWidth":0,"blurHeight":0};